import { useRouteError } from "react-router";
import { ChunkLoadError, isChunkLoadError } from "./ChunkLoadError.tsx";

export function NestedErrorBoundary() {
    const error = useRouteError();

    if (isChunkLoadError(error)) {
        return <ChunkLoadError variant="nested" />;
    }

    // Bubble up the error to a parent error boundary.
    throw error;
}
